import { injectCssPropertiesIntoRootElementMutatorFactory } from './inject-css-properties-into-root-element';
import { elementMutatorFactory } from './element-mutator';
export const listPropsInjectorFactory = ({ experiments, }) => {
    const rootElementObject = {
        padding: '0',
        'margin-top': 0,
        'margin-right': 0,
        'margin-bottom': 0,
        'margin-left': 0,
    };
    const mutators = [
        injectCssPropertiesIntoRootElementMutatorFactory(rootElementObject, experiments),
    ];
    mutators.push(elementMutatorFactory(($el) => {
        const isRtl = $el.is('[dir="rtl"]');
        const paddingLeft = isRtl ? 0 : 24;
        const paddingRight = isRtl ? 24 : 0;
        $el.css('padding-left', `${paddingLeft}px`);
        $el.css('padding-right', `${paddingRight}px`);
    }));
    return {
        elements: ['ol', 'ul'],
        mutators,
    };
};
//# sourceMappingURL=inject-missing-list-props.js.map